import {
  writeGuestGameplaySetting,
  type GuestGameplaySettingKey,
} from "#/lib/guestGameplaySettings";
import { updateMyGameplaySetting } from "#/server/updateMyGameplaySetting";

export function persistGameplaySetting({
  setting,
  enabled,
  isAnonymous,
}: {
  setting: GuestGameplaySettingKey;
  enabled: boolean;
  isAnonymous: boolean;
}): Promise<void> {
  if (isAnonymous) {
    writeGuestGameplaySetting({ setting, enabled });
    return Promise.resolve();
  }
  return updateMyGameplaySetting({ data: { setting, enabled } }).then(() => undefined);
}
